import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z$1 from './styles/groupsite-feature.scss.js';
import css_248z from './styles/feature.scss.js';

class FeatureHighlight extends s {
    constructor() {
        super();
        this.landscape = false;
        this.right = false;
        this.rtl = false;
        this.isGroupsite = false;
        this._query = '(max-width: 1365px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    firstUpdated() {
        var _a;
        if (this.rtl || isRTL())
            (_a = this.querySelector('.rich-text')) === null || _a === void 0 ? void 0 : _a.classList.add('rtl');
    }
    render() {
        const containerClassMap = {
            rtl: this.rtl || isRTL(),
            landscape: this.landscape,
            right: this.right,
        };
        const cta = x `<slot name="cta"></slot>`;
        return x `<article class="${o(containerClassMap)}"><div class="text-container"><div class="text-container-inner"><div class="tags"><slot name="tag"></slot></div><slot name="headline"></slot><slot name="body"></slot>${this._isMobile ? '' : cta}</div></div><div class="img-container"><slot name="img"></slot></div>${this._isMobile ? cta : ''}</article><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
FeatureHighlight.styles = [css_248z, css_248z$1];
__decorate([
    n({ type: Boolean })
], FeatureHighlight.prototype, "landscape", void 0);
__decorate([
    n({ type: Boolean })
], FeatureHighlight.prototype, "right", void 0);
__decorate([
    n({ type: Boolean })
], FeatureHighlight.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], FeatureHighlight.prototype, "isGroupsite", void 0);
customElements.define('feature-highlight', FeatureHighlight);

export { FeatureHighlight };
